import {connect} from "react-redux";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";

import {getStringFeatureName} from "../../misc/helpers";
import {truncate} from "../sqft/helpers/sqftHelper";

const FeatureName = (props) => {
  const {feature, intl, fabricatorData, maxLength, filterGroups, useCollectionName} = props;
  let stringFeatureName = getStringFeatureName(feature, intl.messages, intl.locale, fabricatorData, filterGroups, useCollectionName);
  return parseInt(maxLength) === maxLength ? truncate(stringFeatureName, maxLength) : stringFeatureName;
};

FeatureName.propTypes = {
  maxLength: PropTypes.number,
  feature: PropTypes.object.isRequired,
  useCollectionName: PropTypes.bool,
}

const mapStateToProps = (store) => {
  const {filterGroups} = store.filterState;
  return {
    fabricatorData: store.fabricatorState,
    filterGroups,
  };
};

const mapDispatchToProps = {};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(FeatureName)
)

